// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"97be736f","437":"afb4d425","525":"1fa86863"}[chunkId] + ".chunk.js";
};